import React, {HTMLProps} from 'react';
import {classNames} from "../../../../services/string";

// Component ----

type FieldHelpProps = HTMLProps<HTMLParagraphElement> & {
    isError?: boolean
}

function FieldHelp({children, isError, ...props}: FieldHelpProps) {
    return (
        <p className={classNames('mt-2 text-xs', isError ? 'text-red-600' : 'text-gray-500')} {...props}>
            {children}
        </p>
    );
}

export default FieldHelp;